export default __webpack_public_path__ + "static/media/ivanv_s.442cdb50.jpg";